import React, { useCallback } from 'react';
import * as slice from "../../store/profile/profileSlice";
import { useAppDispatch, useAppSelector } from "../../store/hook";
import { profileActions } from '../../store/profile/profileSlice';

export const useProfile = () => {
    const dispatch = useAppDispatch();
    return {
        loadProfile: useCallback((payload) => {
            dispatch(profileActions.loadProfile(payload));
        }, [dispatch]),
        setProfile: useCallback((payload) => {
            dispatch(profileActions.setProfile(payload));
        }, [dispatch]),
       

        profile: useAppSelector(slice.getProfile),

    }
}